import { render, staticRenderFns } from "./LmBtnUpdateContent.vue?vue&type=template&id=67727e58&scoped=true"
import script from "./LmBtnUpdateContent.vue?vue&type=script&lang=js"
export * from "./LmBtnUpdateContent.vue?vue&type=script&lang=js"
import style0 from "./LmBtnUpdateContent.vue?vue&type=style&index=0&id=67727e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67727e58",
  null
  
)

export default component.exports